// eslint-disable-next-line import/prefer-default-export
export const getFileExtension = (filename) => (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
